module.exports = __webpack_public_path__ + "static/media/sprite_ring-text-specs.f0369b17.svg";